import { useState } from 'react';
import { Modal } from 'antd';
import React from 'react';

interface ConfirmModalProps {
  trigger: React.ReactNode;
  title?: string;
  content?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  width?: number;
  onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  trigger,
  title = 'Подтверждение',
  content = 'Вы уверены?',
  okText = 'Да',
  cancelText = 'Отмена',
  width = 400,
  onConfirm,
}) => {
  const [open, setOpen] = useState(false);

  const handleOk = () => {
    onConfirm();
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <span onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
        {trigger}
      </span>

      <Modal
        title={title}
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={okText}
        cancelText={cancelText}
        width={width}
      >
        {content}
      </Modal>
    </>
  );
};

export default ConfirmModal;